// local lib
import generateColumn from './generateColumn.lib';

const getUsedTechnologiesColumns = () => [
  generateColumn({category: 'activeTechCount', title: 'Active Tech Count'}),
];

export default getUsedTechnologiesColumns;
